<div class="card card--{{ variant() }}">
  <ng-content></ng-content>
</div>
